const lightTheme = {
  "token": {
    "colorPrimary": "#974e55",
    "colorInfo": "#974e55",
    "colorWarning": "#efd000",
    "colorSuccess": "#47b410"
  }
}

export default lightTheme;
